import React from 'react'
import moment from 'moment'
import { dataAppDatabase, patientsDatabase, polyglot } from '../../../index'
import BigCalendar from 'react-big-calendar'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import './style.css'
import { ReactModal } from '../../common/ReactModal/ReactModal'
import { StaticFormGroup } from '../../common/StaticFormGroup/StaticFormGroup'
import PropTypes from 'prop-types'
import { renderFormWithContent } from '../../../resources/renderingUtilities'
import { GENDER } from '../../../resources/utilities'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

export default class ConsultationScheduling extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      clickedCell: undefined,
      modalIsOpen: false,
      events: []
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.scheduleConsultationForm = this.scheduleConsultationForm.bind(this)
    this.saveData = this.saveData.bind(this)
  }

  componentWillMount () {
    this.getEvents()
    window.myLogger.info(JSON.stringify({message: 'ConsultationScheduling Component Rendered'}))
  }

  getEvents () {
    const rootRef = dataAppDatabase.ref()
    const scheduledConsultationsRef = rootRef.child('crescendo').child('scheduledConsultations')
    scheduledConsultationsRef.on('value', snapshot => {
      let events = []
      snapshot.forEach((childSnap) => {
        const start = new Date(`${childSnap.child('date').val()} ${childSnap.child('startTime').val()}`)
        const end = new Date(`${childSnap.child('date').val()} ${childSnap.child('endTime').val()}`)
        const event = {
          id: childSnap.key,
          title: `${polyglot.t('staticFields.consultationScheduling.patientNumber')} - ${childSnap.child('patientNumber').val()}`,
          start: start,
          end: end,
          fullData: childSnap.val()
        }
        events.push(event)
      })
      if (events) {
        this.setState({
          events: events
        })
      }
    })
  }

  getColorForGender (gender) {
    if (gender === GENDER.GIRL) {
      return '#ffcce6'
    } else {
      return '#cde6ff'
    }
  }

  eventStyleGetter (event, start, end, isSelected) {
    let backgroundColor = this.getColorForGender(event.fullData && event.fullData.gender)
    let style = {
      backgroundColor: backgroundColor,
      opacity: 0.8,
      color: 'black',
      border: '0px',
      display: 'block'
    }
    return {
      style: style
    }
  }

  renderCalendar () {
    return <div>
      <BigCalendar
        height='100%'
        selectable
        culture={'pt-PT'}
        messages={{'today': 'Hoje', 'previous': '<', 'next': '>', 'month': 'Mês', 'week': 'Semana', 'day': 'Dia', 'allDay': 'Todo dia', 'date': 'Data', 'time': 'Hora', 'event': 'Evento'}}
        events={this.state.events}
        views={['month', 'week', 'day', 'agenda']}
        defaultView='week'
        // components={{
        //   toolbar: CustomToolbar
        // }}
        defaultDate={moment(moment().toDate().setHours(0, 0, 0)).toDate()}
        eventPropGetter={(this.eventStyleGetter.bind(this))}
        onSelectEvent={event => this.handleEventClick(event)}
        onSelectSlot={cell => this.handleCellClick(cell)} />
    </div>
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  renderContentForModal () {
    if (this.state.clickedCell) {
      if (this.state.clickedCell.hasOwnProperty('fullData')) {
        return this.renderClickedConsultationModal()
      } else {
        if (this.props.configuration && this.props.configuration['consultationScheduling']) {
          return this.scheduleConsultationForm()
        }
      }
    } else {
      return null
    }
  }

  handleEventClick (event) {
    this.setState({
      clickedCell: event
    }, this.toggleModal())
  }
  handleCellClick (cell) {
    this.setState({
      clickedCell: cell
    }, this.toggleModal())
  }

  saveData (data) {
    const { patientNumber } = data
    const rootRef = dataAppDatabase.ref()
    let patient
    patientsDatabase.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.child('patientNumber').val() === patientNumber) {
          patient = childSnap.val()
        }
      })
      if (patient) {
        const consultationsRef = rootRef.child('crescendo').child('scheduledConsultations')
        data['gender'] = patient.gender
        data['allDay'] = false
        consultationsRef.push(data)
        // this.msg.success(polyglot.t('staticFields.consultationScheduling.consultationScheduledSuccessfully'))
        this.toggleModal()
        this.setState({
          clickedCell: undefined
        })
      } else {
        // this.msg.error(polyglot.t('staticFields.consultationScheduling.noPatientForNumber'))
      }
    })
  }

  scheduleConsultationForm () {
    return renderFormWithContent(
      this.props.configuration['consultationScheduling'],
      this.saveData,
      {data: {
        consultationScheduling: {
          date: moment(this.state.clickedCell.start).format(dateFormat.standartData),
          startTime: moment(this.state.clickedCell.start).format('LT'),
          endTime: moment(this.state.clickedCell.end).format('LT')}}}
    )
  }

  renderClickedConsultationModal () {
    return <div className={'col-xs-12 form-horizontal'}>
      <div key={'patientNumber'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.patientNumber`)}
          value={this.state.clickedCell.fullData.patientNumber} />
      </div>
      <div key={'location'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.location`)}
          value={this.state.clickedCell.fullData.location || polyglot.t('staticFields.commonFields.notDefined')} />
      </div>
      <div key={'doctor'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.doctor`)}
          value={this.state.clickedCell.fullData.doctor} />
      </div>
      <div key={'date'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.date`)}
          value={this.state.clickedCell.fullData.date} />
      </div>
      <div key={'startTime'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.startTime`)}
          value={this.state.clickedCell.fullData.startTime} />
      </div>
      <div key={'endTime'} className={'col-xs-12'}>
        <StaticFormGroup
          label={polyglot.t(`staticFields.consultationScheduling.endTime`)}
          value={this.state.clickedCell.fullData.endTime} />
      </div>
    </div>
  }

  render () {
    return <div>
      <h1 style={{alignContent: 'center'}}>Em desenvolvimento</h1>
      {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
      <div className={'col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'}>
        {this.renderCalendar()}
      </div>
      <ReactModal name={polyglot.t(`staticFields.consultationScheduling.consultation`)} toggleModal={() => { this.toggleModal(); this.setState({clickedCell: undefined}) }} modalIsOpen={this.state.modalIsOpen}>
        <div className={'clearfix'}>
          {this.renderContentForModal()}
        </div>
      </ReactModal>
    </div>
  }
}

ConsultationScheduling.propTypes = {
  configuration: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/ConsultationScheduling/ConsultationScheduling.js